import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify';
import firebase from 'firebase';

Vue.config.productionTip = false

var firebaseConfig = {
  apiKey: "AIzaSyC-1wxEkUgNqGWwEg0Y_f7kjnvsHtnMNXE",
  authDomain: "encuestascomedor.firebaseapp.com",
  databaseURL: "https://encuestascomedor.firebaseio.com",
  projectId: "encuestascomedor",
  storageBucket: "",
  messagingSenderId: "1054073186818",
  appId: "1:1054073186818:web:83f291603b51b9e7c5d51b"
};
// Initialize Firebase
firebase.initializeApp(firebaseConfig);

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')